import BannerSection from '../components/partials/home/banner-section';
import FeaturedCollection from '../components/partials/home/featured-collection';
import SaleBanner from '../components/partials/home/sale-banner';
import { useAxios } from '../hooks/useAxios/useAxios';
import AboutSection from '../components/partials/home/about-section';
import CategoryNavSection from '../components/partials/home/categoryNavSection';
import LivingRoomSection from '../components/partials/home/living-room-section';
import SelectedProductsSection from '../components/partials/home/selected-products-section';
import HomeSection from '../components/partials/home/home-section';
import MetaHeader from '../components/common/MetaHeader';

function Home() {
  const {
    data: diningProducts,
    isLoading: diningLoading,
    error: diningError
  } = useAxios('/public/buyontrust/products', {
    params: {
      page: 0,
      limit: 4,
      store_type: 'furniture',
      category: 'Dining',
      list_type: 'featured'
    }
  });

  const {
    data: bedroomProducts,
    isLoading: bedroomLoading,
    error: bedroomError
  } = useAxios('/public/buyontrust/products', {
    params: {
      page: 0,
      limit: 4,
      store_type: 'furniture',
      category: 'Bedroom',
      list_type: 'featured'
    }
  });

  return (
    <>
      <MetaHeader title={'Home'}/>
      <main
        className={`skeleton-body skel-shop-products ${
          diningLoading || bedroomLoading ? '' : 'loaded'
        }`}
      >
        <HomeSection />
        <BannerSection />
        <CategoryNavSection
          categoryName={'Bedroom'}
          imgUrl={'/images/bedroom/bedroom-background-zoom-calls.png'}
          innerText={
            'Make your dreams a reality! Choose from many amazing options to help create the perfect level of comfort for your needs. Make evenings special, and wake up feeling refreshed.'
          }
          title={'Bedroom Furniture'}
        />
        <FeaturedCollection
          loading={bedroomLoading}
          product={bedroomProducts?.data}
          title={'Bedroom FEATURED PRODUCTS'}
        />
        <CategoryNavSection
          categoryName={'Living Room'}
          imgUrl={'/images/livingroom/living_room.png'}
          innerText={
            'Home is where the heart is.  Make time with your family more meaningful with top-quality sofas, tables, and accent pieces that represent you.'
          }
          reversed
          title={'Primary Living Space'}
        />
        <LivingRoomSection />
        <CategoryNavSection
          categoryName={'Dining'}
          imgUrl={'/images/dining/interior-design-with-photoframe-table.png'}
          innerText={
            'Select the perfect options to make your dining experience a bite to remember! Choose from a variety of sizes and styles that expand your comfort from a busy workday to a holiday family gathering.'
          }
          title={'Dining Furniture'}
        />
        <FeaturedCollection
          loading={diningLoading}
          product={diningProducts?.data}
          title={'Find the dining room products of your dreams'}
        />
        <SaleBanner />
        <SelectedProductsSection />
        <AboutSection />
      </main>
    </>
  );
}

export default Home;
